import React from 'react';
import styled from 'styled-components';
import { colors, spaces, typography } from '../../lib/styles';
import { BreadCrumbsSchema } from '../Schema';

export interface BreadCrumb {
    label: string;
    path?: string;
}

const List = styled.ul`
    margin: 0;
    padding: 0;
    line-height: 1;
`;

const ListItem = styled.li`
    display: inline-block;
    font-size: ${typography.typeScale.size2}px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${colors.grey600};
    font-weight: ${typography.fontWeights.bold};

    &:first-child {
        margin-left: 0;
    }

    &:not(:first-child):before {
        content: '/';
        margin: 0 ${spaces.space5}px;
        font-weight: ${typography.fontWeights.normal};
    }
`;

const Link = styled.a`
    color: ${colors.grey600};
    font-weight: ${typography.fontWeights.normal};
    text-decoration: none;

    &:hover {
        text-decoration: underline;
        color: ${colors.grey600};
    }
`;

interface Props {
    breadcrumbs: BreadCrumb[];
}

function BreadCrumbs({ breadcrumbs }: Props) {
    return (
        <>
            <BreadCrumbsSchema breadcrumbs={breadcrumbs} />

            <List>
                {breadcrumbs.map((breadcrumb, index) => (
                    <ListItem key={index} data-testid="bread-crumb-list-item">
                        {breadcrumb.path ? (
                            <Link href={breadcrumb.path}>{breadcrumb.label}</Link>
                        ) : (
                            breadcrumb.label
                        )}
                    </ListItem>
                ))}
            </List>
        </>
    );
}

export default BreadCrumbs;
